import { Box } from '@mui/material';

export const PharmacyAdmin = () => {
    return <Box sx={{ flex: 1 }}>Pharmacy Admin</Box>;
};
